import React, { useState } from 'react';
import { BarChart as eBarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import PropTypes from 'prop-types';

import { ITPMETRICS_BLUE, ITPMETRICS_YELLOW } from '../common/Colours';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  eBarChart,
  CanvasRenderer,
  LegendComponent,
  MarkLineComponent,
]);

export function ReportLeadershipBarChart({
  labels, data, data2, highlightHeader,
}) {
  const [chartImage, setChartImage] = useState(null);
  const series = [{
    type: 'bar',
    name: 'Total',
    data,
    markLine: {
      symbol: 'none',
      data: [{
        xAxis: 25,
        label: { show: false, formatter: () => '' },
        lineStyle: { color: ITPMETRICS_YELLOW, width: 2, type: 'dotted' },
      }, {
        xAxis: 75,
        label: { show: false, formatter: () => '' },
        lineStyle: { color: ITPMETRICS_YELLOW, width: 2, type: 'dotted' },
      }],
    },
    itemStyle: {
      borderRadius: [0, 3, 3, 0],
      color: () => ITPMETRICS_YELLOW,
    },
    showSymbol: false,
    symbol: 'circle',
    smooth: false,
    emphasis: {
      scale: true,
    },
    label: {
      show: true,
      position: 'right',
    },
  }];
  if (data2.length > 0) {
    series.push(
      {
        type: 'bar',
        name: 'Total',
        data: data2,
        itemStyle: {
          borderRadius: [0, 3, 3, 0],
          color: () => ITPMETRICS_BLUE,
        },
        showSymbol: false,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true,
        },
        label: {
          show: true,
          position: 'right',
        },
      },
    );
  }
  const getOption = () => ({
    animation: false,
    tooltip: {
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: 'white',
      borderColor: 'black',
      textStyle: { color: 'dark' },
      borderWidth: 1,
      transitionDuration: 0,
      axisPointer: {
        type: 'none',
      },
      formatter: (params) => {
        if (params.length === 2) {
          return `Self ${params[0].name}: ${Number(params[0].value).toFixed(2)}<br>Other ${params[1].name}: ${Number(params[1].value).toFixed(2)}`;
        }
        return `${params[0].name}: ${Number(params[0].value).toFixed(2)}`;
      },
    },
    xAxis: [{
      type: 'value',
      boundaryGap: '0%',
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
      splitLine: { show: true },
      splitNumber: 5,
      max: 5,
    }, {
      position: 'bottom',
      axisLine: { show: false },
      axisTick: { show: false },
      data: ['Low', 'Moderate', 'High'],
    }],
    yAxis: {
      type: 'category',
      data: labels,
      boundaryGap: '0%',
      axisLabel: {
        rich: {
          b: {
            fontWeight: 'bold',
          },
        },
        formatter(value, index) {
          if (highlightHeader && index === data.length - 1) {
            return `{b|${value}}`;
          }
          return value;
        },
        show: true,
        margin: 15,
      },
      splitLine: {
        show: false,
        lineStyle: {},
      },
      axisTick: { show: true },
      axisLine: {
        lineStyle: {},
      },
    },
    series,
    grid: {
      containLabel: true,
      right: '0px',
      left: '0px',
      bottom: '10px',
      top: '0px',
    },
  });
  return (
    <>
      <img alt="bar-chart" src={chartImage} style={{ width: '100%' }} className="print-only" />
      <ReactEChartsCore
        className="no-print"
        echarts={echarts}
        option={getOption()}
        style={{ height: '20em' }}
        ref={(e) => {
          if (e) {
            setChartImage(e.getEchartsInstance().getDataURL());
          }
        }}
      />
    </>

  );
}

ReportLeadershipBarChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.string),
  data2: PropTypes.arrayOf(PropTypes.string),
  highlightHeader: PropTypes.bool,
};

ReportLeadershipBarChart.defaultProps = {
  highlightHeader: false,
  labels: [],
  data: [],
  data2: [],
};
